import { FormDataComment } from './comment';
import { FormDataHistory } from './form-data-history';

export class JSONFormData {
    id = 0;
    form_id = 0;
    name = '';
    manu = '';
    unitAmount = '0';
    chapter = '';
    type = 'course';
    newState = '';
    currentState = 'draft';
    reviewComment = '';
    data: Array<{}> = [];
    actions: Array<string> = [];
    comments: Array<FormDataComment> = [];
    audits: Array<FormDataHistory> = [];
    transitions: Array<string> = [];
    updated_at: string;
    created_at: string;
    updated_by: any;
    created_by: any;
}

export class JSONFormDataResponse {
    message = '';
    formData: JSONFormData = new JSONFormData();
    formsData: JSONFormData[] = [];
    info:any[];
}

